module.exports = __webpack_public_path__ + "static/img/7.476498f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/7.png
// module id = A8Py
// module chunks = 0